import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';
import { getPropertyTypeImages } from '../../api/clients/propertyTypeImages';

const initialState = {
  imageUrls: {},
  loading: false
};

const prefix = actionPrefix('propertyTypeImages');

// Actions
const FETCH_REQUEST = prefix('FETCH_REQUEST');
const FETCH_ERROR = prefix('FETCH_ERROR');
const FETCH_SUCCESS = prefix('FETCH_SUCCESS');

// Reducers
export default createReducer(initialState, {
  [FETCH_REQUEST](state, { payload }) {
    return {
      ...state,
      ...payload,
      loading: true
    };
  },
  [FETCH_ERROR](state, { payload }) {
    return {
      ...initialState,
      error: payload
    };
  },
  [FETCH_SUCCESS](state, { payload }) {
    return {
      ...state,
      imageUrls: payload,
      loading: false
    };
  }
});

// Action creators
export const request = payload => ({
  type: FETCH_REQUEST,
  payload
});

export const throwError = payload => ({
  type: FETCH_ERROR,
  payload
});

export const success = payload => ({
  type: FETCH_SUCCESS,
  payload
});

// Effects
export const fetchPropertyTypeImages = options => (dispatch, getState) => {
  const items = getState().content.propertyTypes.items;
  const tags = items.map(({ typeId }) => typeId);
  const { system: { siteName }} = getState();
  dispatch(request(options));
  getPropertyTypeImages(tags, siteName)
    .then(data => dispatch(success(data)))
    .catch(({ message }) => dispatch(throwError(message)));
};
